// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__rTTqs","log":"ModalInventoryLogs_log__1ctZl","date":"ModalInventoryLogs_date__2WVWX","userName":"ModalInventoryLogs_userName__CYp48"};